import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getUserDictionaries } from "../util/wordywhiz";
import DictionaryCard from "./DictionaryCard";
import AdSlot from "../../AdSlot";

function UserDictionaries() {
  const navigate = useNavigate();
  const [dictionaries, setDictionaries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    getUserDictionaries()
      .then((dicts) => setDictionaries(dicts))
      .catch(() => setError("Could not load dictionaries. Please log in again."))
      .finally(() => setIsLoading(false));
  }, []);

  const noDicts = !isLoading && !error && dictionaries.length === 0;

  return (
    <div className="study-page">
      <div className="study-header">
        <p className="study-eyebrow">Wordy Whiz · Learn</p>
        <h1>My Dictionaries</h1>
        <p>Word lists you've uploaded.</p>
      </div>

      {isLoading && <div className="dict-spinner" />}
      {error && <p className="dict-state dict-state--error">{error}</p>}

      {noDicts && (
        <div className="dict-state">
          <p>No dictionaries found!</p>
          <p>Upload a dictionary or browse public ones to get started.</p>
          <div className="dict-config__actions dict-config__actions--row">
            <button className="ww-btn ww-btn--primary" onClick={() => navigate("/wordy-whiz/upload")}>
              Upload dictionary
            </button>
            <button className="ww-btn ww-btn--secondary" onClick={() => navigate("/wordy-whiz/dictionaries")}>
              Public dictionaries
            </button>
          </div>
        </div>
      )}

      <div className="dict-grid">
        {dictionaries.map((dict) => (
          <DictionaryCard
            key={dict.id}
            dict={dict}
            onClick={() => navigate(`/wordy-whiz/dictionary/${dict.id}`)}
          />
        ))}
      </div>

      <AdSlot slot={process.env.REACT_APP_ADSENSE_SLOT_DICTIONARIES} className="mt-4" />
    </div>
  );
}

export default UserDictionaries;
